import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import shravantidoc from '../../../../assets/images/Doctorsimages/dr.shravanti.png' 
import favicon from "./../../../../assets/images/favicon.ico"
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const ShravantiDoc = () => {
  const navigate = useNavigate(); 

  useEffect(() => {
    document.title = "Dr. Shravanti Ramesh Maile | Best Homeopathy & Aesthetic Physician in Gachibowli Hyderabad";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Consult Dr. Shravanti Ramesh Maile (BHMS, PG Dip. In Facial Aesthetic and Clinical Cosmetologist), a trusted homeopathy and aesthetic physician in Gachibowli, Hyderabad. Expert in personalized, safe treatments for holistic wellness, skin, and hair care. Book your consultation today."
      );
    }
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "best homeopathy doctor in Gachibowli Hyderabad, aesthetic physician in Hyderabad, female homeopathy doctor in Gachibowli, homeopathy doctor for skin and hair in Hyderabad, consultant homeopathy doctor near me, holistic wellness doctor Hyderabad, Dr. G.D. Pol Foundation alumni doctor, safe homeopathy treatments Hyderabad, aesthetic skin treatments Gachibowli, homeopathy for chronic diseases Hyderabad, top aesthetic physician in Gachibowli, personalized homeopathy care Hyderabad, consultant aesthetic doctor near me, Yashodara hospital experience doctor"
      );
    }

    const existingCanonical = document.querySelector("link[rel='canonical']");
    const canonicalUrl = "https://www.h-cura.com/doctors/dr-vijaya-lakshmi-dasari-hyderabad-gachibowli";
    if (existingCanonical) {
      existingCanonical.setAttribute("href", canonicalUrl);
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", canonicalUrl);
      document.head.appendChild(canonicalLink);
    }

    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }
  }, []);

  const handleDownloadPdf = () => {
    const container = document.querySelector('.veenadoc');
    container.classList.add('veenadoc-pdf-mode');
    const originalStyles = new Map();
    const allElements = container.querySelectorAll('*');

    allElements.forEach(el => {
      originalStyles.set(el, {
        transition: el.style.transition,
        animation: el.style.animation,
        transform: el.style.transform,
        filter: el.style.filter
      });
      el.style.transition = 'none';
      el.style.animation = 'none';
      el.style.transform = 'none';
      el.style.filter = 'none';
    });

    const heroSection = container.querySelector('.veenadoc-hero-section');
    if (heroSection) {
      heroSection.style.minHeight = 'auto';
      heroSection.style.padding = '40px 0';
    }

    const images = container.querySelectorAll('img');
    images.forEach(img => {
      img.style.opacity = '1';
    });

    setTimeout(() => {
      html2canvas(container, {
        scale: 2,
        dpi: 300,
        useCORS: true,
        allowTaint: true,
        letterRendering: true,
        backgroundColor: '#ffffff',
        logging: false,
        windowWidth: container.scrollWidth,
        windowHeight: container.scrollHeight,
        scrollY: -window.scrollY,
        scrollX: -window.scrollX,
        imageTimeout: 0,
        removeContainer: false
      }).then(canvas => {
        container.classList.remove('veenadoc-pdf-mode');
        allElements.forEach(el => {
          const original = originalStyles.get(el);
          if (original) {
            el.style.transition = original.transition;
            el.style.animation = original.animation;
            el.style.transform = original.transform;
            el.style.filter = original.filter;
          }
        });

        if (heroSection) {
          heroSection.style.minHeight = '';
          heroSection.style.padding = '';
        }

        const imgData = canvas.toDataURL('image/jpeg', 0.95);
        const pdf = new jsPDF('p', 'mm', 'a4', true);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;
        const marginLeft = 10;
        const marginRight = 10;
        const availableWidth = pdfWidth - marginLeft - marginRight;
        const scaleFactor = availableWidth / canvasWidth;
        const imgWidth = canvasWidth * scaleFactor;
        const imgHeight = canvasHeight * scaleFactor;
        const pages = Math.ceil(imgHeight / pdfHeight);

        for (let i = 0; i < pages; i++) {
          if (i > 0) pdf.addPage();
          pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
        }
        pdf.save('Dr_Shravanti_Ramesh_Maile_Profile.pdf');
      }).catch(error => {
        console.error('Error generating PDF:', error);
        container.classList.remove('veenadoc-pdf-mode');
        allElements.forEach(el => {
          const original = originalStyles.get(el);
          if (original) {
            el.style.transition = original.transition;
            el.style.animation = original.animation;
            el.style.transform = original.transform;
            el.style.filter = original.filter;
          }
        });
      });
    }, 100);
  };

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Shravanti Ramesh Maile</span>
                  <span className="veenadoc-title-credentials">(BHMS, PG Dip. In Facial Aesthetic and Clinical Cosmetologist)</span>
                  <span className="veenadoc-title-location">Gachibowli, Hyderabad</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    A highly regarded practitioner in Gachibowli, Hyderabad, known for her unique integration of traditional 
                    homeopathy and modern aesthetic medicine. As a Consultant Homeopathy and Aesthetic Physician, she offers 
                    a comprehensive approach to health that prioritizes long-term wellness alongside visible aesthetic improvements.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button className="veenadoc-btn-primary-gradient" onClick={() => navigate('/bookconsultation')}>
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={shravantidoc} alt="Dr. Shravanti Ramesh Maile - Best Homeopathy & Aesthetic Physician in Gachibowli Hyderabad" className="veenadoc-doctor-image" title='Dr. Shravanti Ramesh Maile – Best Homeopathy & Aesthetic Physician in Gachibowli Hyderabad' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">
              <div className="veenadoc-article-main">
                
                <div className="veenadoc-article-block">
                  <h2>About Dr. Shravanti Ramesh Maile</h2>
                  <p>
                   Dr. Shravanti earned her degree from the prestigious Dr. G.D. Pol Foundation (YMT Homoeopathic Medical College) Navi Mumbai, where she developed a deep understanding of holistic healing and clinical excellence. Her professional background includes valuable experience at the renowned Yashodara Superspeciality Hospital , Solapur.
                  </p>
                  <p>
                    With three years of intensive practice, she has shaped herself into a compassionate healer who understands 
                    the nuances of patient care in high-standard medical environments. This allows her to bridge the gap 
                    between specialized hospital-grade care and the personalized touch of holistic homeopathy.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Clinical Journey & Professional Experience</h2>
                  <p>
                    During her tenure at Yashodara Superspeciality Hospital, Dr. Shravanti handled a wide array of clinical cases, 
                    ranging from chronic systemic illnesses to advanced skin and hair concerns. This diverse exposure has 
                    refined her ability to diagnose complex conditions and provide effective, safe interventions.
                  </p>
                  <p>
                    Patients searching for a "consultant homeopathy doctor near me" find in Dr. Shravanti a professional who 
                    not only provides remedies but also focuses on lifestyle correction, nutrition, and long-term wellness.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BHMS, PG Dip. In Facial Aesthetic and Clinical Cosmetologist</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">3 Years</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Homeopathy & Aesthetics</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Location:</span>
                      <span className="veenadoc-info-value">Gachibowli, Hyderabad</span>
                    </div>
                  </div>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Expertise in Chronic & Holistic Healing</h2>
                  <p>
                    Dr. Shravanti specializes in treating chronic conditions using the gentle yet powerful principles of homeopathy. 
                    Whether dealing with hormonal imbalances, lifestyle-induced problems, or systemic health issues, she takes 
                    the time to understand the patient’s history and underlying triggers before prescribing personalized remedies.
                  </p>
                  <p>
                    In the vibrant community of Gachibowli, she is a sought-after expert for those seeking natural yet 
                    result-oriented solutions that address internal health imbalances while promoting overall vitality.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Specialized Trichology & Hair Care Solutions</h2>
                  <p>
                    Dr. Shravanti has gained recognition as a trichology doctor in Hyderabad specializing in hair fall,  dandruff, scalp conditions, hair thinning, premature greying, alopecia, and hair regrowth treatments. She also provides advanced hair therapies such as PRP (Platelet-Rich Plasma), GFC (Growth Factor Concentrate), Mesotherapy, Stem Cell Therapy, Laser Hair Therapy and exosome  to ensure effective and long-lasting results.
                  </p>
                  <p>
                    Her expertise ensures that patients not only regain healthy hair but also confidence and peace of mind.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Aesthetic Physician & Skin Care Expert</h2>
                  <p>
                    Her dual qualification in Homeopathy and Medical Cosmetology (PG Dip. In Facial Aesthetic and Clinical Cosmetologist) allows her to provide advanced 
                    aesthetic treatments for skin rejuvenation, pigmentation removal, and acne management. She combines 
                    safe homeopathic remedies with modern aesthetic procedures to restore skin health without harmful side effects.
                  </p>
                  <p>
                    Patients searching for an aesthetic physician for skin and hair care in Hyderabad appreciate her ability 
                    to deliver glowing results through science-backed, personalized care that enhances natural beauty.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>What Makes Dr. Shravanti Unique</h2>
                  <p>
                    What makes Dr. Shravanti unique is her ability to see the patient as a whole person. While many doctors 
                    specialize in only one field, she integrates homeopathy and aesthetics seamlessly. This ensures that 
                    her patients don't just receive cosmetic improvements but also achieve long-term health benefits.
                  </p>
                  <p>
                    Whether someone is searching for the best homeopathy doctor for chronic diseases or a female skin specialist 
                    in Gachibowli, Dr. Shravanti’s profile appears as a reliable choice because of her results-driven yet 
                    patient-friendly approach.
                  </p>
                </div>

                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choose Dr. Shravanti Ramesh Maile for Holistic Care</h2>
                  <p>
                    Choosing Dr. Shravanti means selecting a physician who is committed to your complete health and well-being. 
                    She provides the assurance of safe treatments, the expertise of modern aesthetic science, and the 
                    compassion of a holistic healer.
                  </p>
                  <p>
                    For anyone searching for the best homeopathy and aesthetic physician in Hyderabad, Dr. Shravanti is the 
                    professional who brings together medical excellence, artistic vision, and genuine patient empathy.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her mission:</strong> To provide a higher standard of care where safety, empathy, and clinical 
                    precision meet to empower patients with healthier lives.
                  </p>
                </div>
              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote>
                      "I focus on understanding my patients first, then creating safe, personalized treatment plans that suit their needs"
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Shravanti's Philosophy of Care</p>
                  </div>
                  <p>
                    She believes that true healing begins with a deep connection and a thorough understanding of the 
                    individual’s lifestyle, emotional well-being, and physical symptoms.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Practice Location</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Gachibowli, Hyderabad</h4>
                      <p>Primary Practice Location</p>
                    </div>
                  </div>
                </div>

                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience safe and personalized holistic healing with Dr. Shravanti Ramesh Maile.</p>
                  <button className="veenadoc-sidebar-btn-primary" onClick={() => window.location.href = 'tel:+919964688333'}>
                    <span>📞</span>
                    <span>Schedule Appointment</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow/>

      <div className="bangloregfcblog-download-section">
        <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
          Download This Doctor profile as PDF
        </button>
      </div>
    </>
  )
}

export default ShravantiDoc
